// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__14gk7","root-container":"classes_root-container__3TGCo","root-text":"classes_root-text__3eq2J","root-right":"classes_root-right__xdPyX"};